export default "//file.bilionpass.com/japandx-portal/0.1.21/static/img/service-arrow.75b01dd0-319487.svg";